import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::store
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/dashboard/column',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::store
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::store
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::update
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column/{column}'
*/
export const update = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/dashboard/column/{column}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::update
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column/{column}'
*/
update.url = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { column: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { column: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            column: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        column: typeof args.column === 'object'
        ? args.column.id
        : args.column,
    }

    return update.definition.url
            .replace('{column}', parsedArgs.column.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::update
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column/{column}'
*/
update.put = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::destroy
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column-delete/{column}'
*/
export const destroy = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/dashboard/column-delete/{column}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::destroy
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column-delete/{column}'
*/
destroy.url = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { column: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { column: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            column: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        column: typeof args.column === 'object'
        ? args.column.id
        : args.column,
    }

    return destroy.definition.url
            .replace('{column}', parsedArgs.column.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboardColumnsController::destroy
* @see app/Http/Controllers/TemplateDashboardColumnsController.php
* @route '/api/dashboard/column-delete/{column}'
*/
destroy.delete = (args: { column: string | number | { id: string | number } } | [column: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const TemplateDashboardColumnsController = { store, update, destroy }

export default TemplateDashboardColumnsController